import type { Props } from '../../types/context';
import type { VendorCardLargeProps } from '../../types/props';

export const isContextLargeProps = <T extends VendorCardLargeProps & Props>(
	unknown: Props,
): unknown is T => unknown.size === 'lg';
